'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './storyStat.routes';

export class StoryStatComponent {
    filters = {
        begin: new Date('2021-01-01'),
        end: new Date('2021-02-15'),
        language_type: 'en'
    };
    array = [];

    /*@ngInject*/
    constructor($http, $location, $cookies) {
        this.message = 'Hello';
        this.$location = $location;
        this.$cookies = $cookies;
        this.language_type_selector = [
            {value: 'en', name: '英语'},
            {value: 'pt', name: '葡语'},
            {value: 'es', name: '西语'},
        ];
        this.$http = $http;
    }

    $onInit() {
        this.search();
    }

    search() {
        if(this.$cookies.get('token')) {
            this.$http
                .get('/api/stranger_community_storys/statistics', {
                    header: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        token: this.$cookies.get('token')
                    },
                    params: this.filters
                })
                .then(response => {
                    if(response.data.data) {
                        this.array = response.data.data;
                    }
                });
        } else {
            this.$location.path('main');
        }
    }
}

export default angular.module('tttApp.storyStat', [uiRouter])
    .config(routes)
    .component('storyStat', {
        template: require('./storyStat.html'),
        controller: StoryStatComponent,
        controllerAs: 'storyStatCtrl'
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/storyStat/storyStat.component.js